/**
 * 用户侧送礼物入口
 * @author zhenn
 * @createTime 2017-12-18
 */

// 多语言文档：https://docs.google.com/spreadsheets/d/1de-Gbi1Bc-sg9Nx0YnPil4vvpWps0AdfMNOiRQDqUpI/edit#gid=0

import '../css/reset.css';
import '../css/gift.css';
import '../css/host.css';

import React, {Component} from 'react';
import {HashRouter, Route, Switch, Redirect} from 'react-router-dom';
import FastClick from 'c-fastclick';
import './lib/object.assign';
import './lib/promise';
import './base/global';
// 登陆相关的API
import './component/openjs/h5';
// 适配域名
import './component/fithost';

//  上拉加载，下拉刷新
import 'c-dropload';
import 'c-dropload/dist/index.css';
// import './lib/mbase';
import GA from './lib/ga';
import {
    Gift,
    IMS,
    SingleChat,
    FriendListView,
    FriendApply,
    LeaderBoard,
    AlipayRedirect,
    WxpayRedirect,
    CreateGiftItem,
    Earnings,
    Land,
    Login,
    PhotoEdit,
    Profile,
    Project,
    ProjectDetail,
    NoPermission,
    Wallet, BlockChainView, GiftShowView
} from './views';
import {isLogined, loginInit} from './component/login';

window.GA = GA;
FastClick.attach(document.body);
try {
    UG.native.setTitle(UG.lang.template('Universal Gifting'));
} catch (e) {
    console.log(e);
}
document.title = UG.lang.template('Universal Gifting');

$.fn.dropload.setDefaults({
    scrollArea: window,
    threshold: 100,
    domDown: { // 下方DOM
        domClass: 'dropload-down',
        domRefresh: `<div class="dropload-refresh">↑${UG.lang.template('Swipe up to load more')}</div>`,
        domLoad: `<div class="dropload-load"><span class="loading"></span>${UG.lang.template('Loading...')}</div>`,
        domNoData: `<div class="dropload-noData">${UG.lang.template('No more data')}</div>`
    }
});

UpSDK.setConfig({
    channel: 'ugift2-gifto',
    language: UG.lang.type
});

const create = (type, Component) => {
    return props => {
        const isLogin = isLogined();
        console.log('开始渲染路由。。。。。。。。。。。login ===> ', isLogin);
        switch (type) {
            case 'singlechat':
                return <SingleChat {...props} key={props.match.params.uid}/>;
            case 'profile':
                return <Profile {...props} key={props.match.params.userId}/>;
            case 'createitem':
                return <CreateGiftItem {...props} key={props.match.params.step}/>;
        }

        if (!isLogin && ['project'].indexOf(type) !== -1) {
            return <Redirect to="/login"/>;
        } else {
            return <Component {...props}/>;
        }
    };
};

const getConfirmation = (message, back) => {
    const {msg, href} = JSON.parse(message);
    UG.confirm({
        title: UG.lang.template('Confirm'),
        content: msg,
        okClick(des) {
            des();
            back(true);
        },
        cancelClick(des) {
            des();
            //  虽然阻止了回退，但是历史也变了，这个是不允许的，所以需要加一下这个
            history.pushState(null, null, href);
            back(false);
        }
    });
};

class App extends Component {

    componentWillMount() {
        let hash = UG.cache.getCache('redirectHash');
        let currentHash = location.hash.substring(1);
        UG.cache.removeCache('redirectHash');

        if (hash && !/undefined/i.test(hash) && hash !== currentHash) {
            UG.router.replace(hash);
        } else {
            if (currentHash && currentHash.indexOf('pl=uplive') !== -1) {
                UG.router.replace('/');
            }
        }

    }

    render() {
        return (
            <HashRouter getUserConfirmation={getConfirmation}>
                <Switch>
                    <Route path="/" exact render={create('project', Project)}/>
                    <Route path="/gift" component={Gift}/>
                    <Route path="/login" component={Login}/>
                    <Route path="/wallet" component={Wallet}/>
                    <Route path="/im" exact component={IMS}/>
                    <Route path="/im/singlechat/:uid" render={create('singlechat')}/>
                    <Route path="/im/friendlist" component={FriendListView}/>
                    <Route path="/im/friendapply" component={FriendApply}/>
                    <Route path="/leaderboard/:id/:userId" component={LeaderBoard}/>
                    <Route path="/profile/:userId" render={create('profile')}/>
                    <Route path="/photoedit" component={PhotoEdit}/>
                    <Route path="/alipayredirect" component={AlipayRedirect}/>
                    <Route path="/wxpayredirect" component={WxpayRedirect}/>
                    <Route path="/land" component={Land}/>
                    <Route path="/project" exact render={create('project', Project)}/>
                    <Route path="/project/detail/:id" component={ProjectDetail}/>
                    <Route path="/createitem/:step/:id" render={create('createitem')}/>
                    <Route path="/createitem/:step" render={create('createitem')}/>
                    <Route path="/earnings/:userId" render={create('earnings', Earnings)}/>
                    <Route path="/blockchain" component={BlockChainView}/>
                    <Route path="/giftshow/:gmid" component={GiftShowView}/>
                </Switch>
            </HashRouter>
        );
    }
}

// alert(navigator.appVersion);
// alert(navigator.vendor);
$('#wrap').css('min-height', $(window).height());

$(window).on('resize', () => {
    $('#wrap').css('min-height', $(window).height());
});

loginInit(App, NoPermission);
// TODO  test login on dev
// http://m.upliveapps.com/ugift2/gifto.html?env=dev#/
// UpSDK.on('getUserSuccess', (data) => {
//     // data 将授权信息直接带回去就可以了
//     console.log(data);
// });
// if (location.href.indexOf('code') < 0) {
//     UpSDK.login({
//         oauthtype: 'line'
//     });
// }



// WEBPACK FOOTER //
// ./js/gift.js